import StyledMenu from "@/app/components/styledMenu";
import { useRunPrivileges } from "@/contexts/privileges/components/RunPrivilegesProvider";
import { openShareModal } from "@/store/actions/shareModal.actions";
import { selectIsExcelAddIn } from "@/store/slices/excel.slice";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import { useSelector } from "react-redux";

export const RunActionsMenu = ({
  runId,
  runName,
  onCopyClick,
  onDelete,
  onDownload,
  onEdit,
}: {
  runId: string;
  runName: string;
  onCopyClick: (type: 'short' | 'bid_offer' | 'default' | 'bid' | 'offer') => void;
  onDelete: () => void;
  onDownload: (type?: 'noDates') => void;
  onEdit: () => void;
}) => {
  const isExcelAddIn = useSelector(selectIsExcelAddIn);
  const { canEdit } = useRunPrivileges();
  const editDisabled = !canEdit();

  return (
    <StyledMenu
      ariaLabel='Run Menu'
      Button={() => <EllipsisVerticalIcon className="h-[1rem] w-[1rem]" aria-hidden="true" />}
      buttonCss='rounded-full'
      menuItems={[
        {
          ariaLabel: 'Copy',
          Item: () => 'Copy',
          key: 'copy',
          onClick: () => onCopyClick('default'),
          subMenu: [
            {
              ariaLabel: 'Copy to Clipboard',
              Item: () => 'Copy to Clipboard',
              key: 'copy',
              onClick: () => onCopyClick('default'),
            },
            {
              ariaLabel: 'Copy Runs',
              Item: () => 'Copy Runs',
              key: 'copy-runs',
              onClick: () => onCopyClick('short'),
            },
            {
              ariaLabel: 'Copy Bids / Offers',
              Item: () => 'Copy Bids / Offers',
              key: 'copy-runs',
              onClick: () => onCopyClick('bid_offer'),
            },
            {
              ariaLabel: 'Copy Bids',
              Item: () => 'Copy Bids',
              key: 'copy-bids',
              onClick: () => onCopyClick('bid'),
            },
            {
              ariaLabel: 'Copy Offers',
              Item: () => 'Copy Offers',
              key: 'copy-offers',
              onClick: () => onCopyClick('offer'),
            }
          ]
        },
        {
          ariaLabel: 'Download',
          Item: () => 'Download',
          key: 'download',
          onClick: () => onDownload(),
          disabled: isExcelAddIn,
          subMenu: [
            {
              ariaLabel: 'Download',
              Item: () => 'Download',
              key: 'download',
              disabled: isExcelAddIn,
              onClick: () => onDownload(),
            },
            {
              ariaLabel: 'Download without dates',
              Item: () => 'Download without dates',
              key: 'download-no-dates',
              disabled: isExcelAddIn,
              onClick: () => onDownload('noDates'),
            },
          ]
        },
        {
          ariaLabel: 'Edit',
          Item: () => 'Edit',
          key: 'edit',
          disabled: editDisabled,
          onClick: () => onEdit()
        },
        {
          ariaLabel: 'Share',
          Item: () => 'Share',
          key: 'share',
          disabled: editDisabled,
          onClick: () => {
            openShareModal({
              objectId: runId,
              objectType: 'run',
              objectName: runName,
            })
          }
        },
        {
          ariaLabel: editDisabled ? 'Remove me from shared list' : 'Delete',
          Item: () => editDisabled ? 'Remove me from share list' : 'Delete',
          key: 'delete',
          // disabled: editDisabled,
          onClick: () => onDelete()
        }
      ]}
    />
  )
}